import { AnalyticsTypeEnum } from '../../../core/enums/analytics-type.enum'
import AnalyticDetailsWorkMirrorView from './work-mirror/AnalyticDetailsWorkMirrorView'
import AnalyticDetailsReadershipProfileView from './readership-profile/AnalyticDetailsReadershipProfileView'
import AnalyticDetailsAuthorMirrorView from './author-mirror/AnalyticDetailsAuthorMirrorView'

const SwitchViewAnalytic = ({
  type,
  handleSaveAnalytics,
  handleShareAnalytics,
}: {
  type: AnalyticsTypeEnum
  handleSaveAnalytics: () => void
  handleShareAnalytics: () => void
}) => {
  switch (type) {
    case AnalyticsTypeEnum.WORK_MIRROR:
    case AnalyticsTypeEnum.PRIVATE_WORK_MIRROR:
      return (
        <AnalyticDetailsWorkMirrorView
          handleSaveAnalytics={handleSaveAnalytics}
          handleShareAnalytics={handleShareAnalytics}
        />
      )
    case AnalyticsTypeEnum.AUTHOR_MIRROR:
    case AnalyticsTypeEnum.PRIVATE_AUTHOR_MIRROR:
      return (
        <AnalyticDetailsAuthorMirrorView
          handleSaveAnalytics={handleSaveAnalytics}
          handleShareAnalytics={handleShareAnalytics}
        />
      )
    case AnalyticsTypeEnum.READERSHIP_PROFILE:
      return (
        <AnalyticDetailsReadershipProfileView
          handleShareAnalytics={handleShareAnalytics}
        />
      )
    default:
      return null
  }
}

export default SwitchViewAnalytic
